import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AgeGate from "./pages/AgeGate";
import AuthPage from "./pages/AuthPage";
import GridPage from "./pages/GridPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import ReservationsPage from "./pages/ReservationsPage";
import AdminPage from "./pages/AdminPage";
import SettingsPage from "./pages/SettingsPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppContent() {
  const [ageVerified, setAgeVerified] = useState(false);
  const isAdminRoute = window.location.pathname.startsWith("/admin");

  useEffect(() => {
    const verified = sessionStorage.getItem("solaro_age_verified");
    if (verified === "true") setAgeVerified(true);
  }, []);

  const handleAgeVerified = () => {
    sessionStorage.setItem("solaro_age_verified", "true");
    setAgeVerified(true);
  };

  if (!ageVerified && !isAdminRoute) {
    return (
      <Routes>
        <Route path="*" element={<AgeGate onVerified={handleAgeVerified} />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route
        path="/grid"
        element={
          <ProtectedRoute>
            <GridPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/confirmation"
        element={
          <ProtectedRoute>
            <ConfirmationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reservations"
        element={
          <ProtectedRoute>
            <ReservationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
